import CheckPermissions from './CheckPermissions';

const Authorized = ({ children, authority, noMatch = null, authorityAll = null }) => {
  const childrenRender = typeof children === 'undefined' ? null : children;
  return CheckPermissions(authority, childrenRender, noMatch, authorityAll);
};

export default Authorized;
